<template>
  <div class="schoolCardList-container">
    <div class="schoolCardList-main flex">
      <main-left only-school @treeNodeClick="treeNodeClick" />
      <div class="schoolCardList-right flex_1 div-layout">
        <div class="schoolCardList-right-contain">
          <module-title title="保修期配置">
            <div class="right">
              <el-button
                type="primary"
                size="medium"
                @click="_visible = false"
              >
                返回
              </el-button>
            </div>
          </module-title>
          <p>{{ treeNode.name }}</p>
          <el-table
            v-loading="listLoading"
            :cell-class-name="cellcb"
            :data="schoolCardList"
            fit
            element-loading-text="Loading"
            class="list-table"
            highlight-current-row
          >
            <el-table-column type="index" label="序号" align="center" />
            <el-table-column label="核销类别" width="100px" prop="provType" align="center">
              <template slot="header">
                核销类别
                <el-tooltip effect="light" placement="bottom">
                  <div slot="content">
                    分为自动核销和手动核销<br>自动核销：通过设备发放助手App发放后自动完成核销；<br> 手动核销：通过运营管理平台单个添加或批量导入设备完成核销。
                  </div>
                  <i class="el-icon-info" />
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                {{ scope.row.provType===2?'手动核销':'自动核销' }}
              </template>
            </el-table-column>
            <el-table-column label="核销日期" prop="provDate" align="center" width="150px">
              <template slot="header">
                核销日期
                <el-tooltip effect="light" placement="bottom">
                  <div slot="content">
                    通过设备发放助手App扫码发放设备的日期或在运营管理平台批量导入设备的日期
                  </div>
                  <i class="el-icon-info" />
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="保修顺延天数" prop="warrantyPostponeDay" align="center" width="150px">
              <template slot="header">
                保修顺延天数
                <el-tooltip effect="light" placement="bottom">
                  <div slot="content">
                    保修顺延天数+核销日期=保修期开始时间
                  </div>
                  <i class="el-icon-info" />
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <template v-if="scope.row.edit">
                  <el-input-number v-model="scope.row.warrantyPostponeDay" size="mini" auto-complete="off" @change="handleFromInputNumber($event,'warrantyPostponeDay',scope.row)" />
                </template>
                <span v-else>{{ scope.row.warrantyPostponeDay }}</span>
              </template>
            </el-table-column>
            <el-table-column label="保修开始日期" prop="warrantyStartDate" align="center" width="120px" />
            <el-table-column label="保修期（天）" align="center" width="120px">
              <template slot-scope="scope">
                <template v-if="scope.row.edit">
                  <el-input-number v-model="scope.row.warrantyDay" size="mini" auto-complete="off" @change="handleFromInputNumber($event,'warrantyDay',scope.row)" />
                </template>
                <span v-else>{{ scope.row.warrantyDay }}</span>
              </template>
            </el-table-column>
            <el-table-column label="保修截止日期" align="center" width="150px">
              <template slot-scope="scope">
                {{ scope.row.warrantyEndDate }}
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="150px">
              <template slot-scope="scope">
                <span v-if="scope.row.edit">
                  <el-button
                    class="cancel-btn cancel"
                    size="small"
                    type="warning"
                    @click="confirmEdit(scope.row,'cancel')"
                  >
                    取消
                  </el-button>
                  <el-button
                    type="success"
                    size="small"
                    icon="el-icon-circle-check-outline"
                    @click="confirmEdit(scope.row,'save')"
                  >
                    保存
                  </el-button>
                </span>
                <el-button
                  v-else
                  type="primary"
                  size="small"
                  icon="el-icon-edit"
                  @click="edit(scope.row)"
                >
                  编辑
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <!-- <el-input-number size="mini" v-model="num" @change="handleChange"></el-input-number> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import tableHeaderTip from '@/components/tableHeaderTip/tableHeaderTip';
import {
  school_plate_repair_config_list,
  school_plate_repair_config_edit
} from '@/api/systemMaintenance/devicManage/warrantyList';
import { getNewData, deepCopy } from '@/utils/index';
export default {
  name: 'WarrantyConfig',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    tableHeaderTip
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      treeNode: {}, // 机构树节点对象
      handleCurrentCard: {}, // 当前点击学生
      searchForm: {
        pageNum: 1,
        pageSize: 10
      },
      handleFrom: {
        warrantyDay: 365,
        warrantyPostponeDay: 0,
        warrantyStartDate: '',
        warrantyEndDate: ''
      },
      listLoading: false, // 表格刷新loading
      schoolCardList: [], //  学生卡列表
      schoolCardListCopy: [],
      validate: false
    };
  },
  computed: {
    // 返回
    _visible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  methods: {
    handleFromInputNumber(val, type, row) {
      this.validate = false;
      var regex = /(^[0-9]\d*$)/;
      if (!regex.test(val) || val > 9999) {
        this.$message({
          message: '请输入0-9999整数!',
          type: 'error',
          duration: 3 * 1000
        });
        this.validate = true;
        return;
      }
      if (type === 'warrantyPostponeDay') {
        this.handleFrom.warrantyPostponeDay = val;
      } else {
        this.handleFrom.warrantyDay = val;
      }
    },
    cellcb({ row, columnIndex }) {
      if (row.deviceNo === 'E1AFDA18' && columnIndex === 0) {
        return 'myCell';
      }
    },
    // 树点击事件
    treeNodeClick(data) {
      this.treeNode = data;
      this.searchForm.schoolCode = this.treeNode.code;
      this.fetchSchoolCardList();
    },
    edit(row) {
      this.schoolCardList.map(item => {
        this.$set(item, 'edit', false);
        return item;
      });
      row.edit = true;
      this.handleFrom.warrantyPostponeDay = row.warrantyPostponeDay;
      this.handleFrom.warrantyDay = row.warrantyDay;
    },
    confirmEdit(row, type) {
      if (type === 'cancel') {
        this.schoolCardList = deepCopy(this.schoolCardListCopy);
        row.edit = false;
      } else {
        if (!this.validate) {
          row.edit = false;
          this.handleFrom.warrantyStartDate = getNewData(row.provDate, this.handleFrom.warrantyPostponeDay);
          this.handleFrom.warrantyEndDate = getNewData(this.handleFrom.warrantyStartDate, this.handleFrom.warrantyDay);
          const op = {
            warrantyDay: this.handleFrom.warrantyDay,
            warrantyPostponeDay: this.handleFrom.warrantyPostponeDay,
            warrantyStartDate: this.handleFrom.warrantyStartDate,
            warrantyEndDate: this.handleFrom.warrantyEndDate,
            schoolCode: this.treeNode.code
          };
          school_plate_repair_config_edit(op, row.id).then((res) => {
            this.$notify.success({
              title: 'Success',
              message: '保存成功',
              showClose: false,
              duration: 2000
            });
            this.fetchSchoolCardList();
          });
        }
      }
    },
    // 获取学生卡列表
    fetchSchoolCardList() {
      school_plate_repair_config_list(this.searchForm).then((res) => {
        if (res.data && res.data.length > 0) {
          this.schoolCardList = res.data;
          this.schoolCardList.map(item => {
            this.$set(item, 'edit', false);
            return item;
          });
          this.schoolCardListCopy = deepCopy(this.schoolCardList);
        } else {
          this.schoolCardListCopy = this.schoolCardList = [];
        }
      });
    }
  }
};
</script>
<style lang="scss">
.abnormal-table {
  height: 500px;
}
</style>
<style lang="scss" scoped>
.schoolCardList-container {
  .schoolCardList-main {
    min-height: 80vh;
    padding-bottom: 20px;
    .schoolCardList-right {
      .schoolCardList-right-contain {
        > p {
          padding-left: 25px;
          font-size: 16px;
          font-weight: bold;
          color: #666666;
          margin-bottom: 20px;
        }
      }
    }
  }
  .edit-form-input {
    width: 8vw;
  }
  .replace-form-input {
    width: 80%;
  }
  .marginleft-10 {
    margin-left: 10px;
  }
  // 查看详情
  .archivesTitle {
    color: #1890ff;
    font-size: 14px;
    font-weight: bold;
    padding-left: 30px;
    padding-bottom: 20px;
  }
  .manager-info {
    ul {
      margin-left: 60px;
      width: 50%;
      min-width: 220px;
      li {
        margin-bottom: 20px;
      }
    }
  }
}
//隐藏的CSS代码
/*按钮日期选择器隐藏ipnut*/
.hide_input{
    position: relative !important;
}
.update-icon{
  cursor: pointer;
  color: rgb(62, 159, 238);
}
//修改控件自带的css
.hide_input .el-date-editor {
    position: absolute ;//绝对定位
    top: 0 ;
    left: 0 ;
    opacity: 0;//设置完全透明
}
 /deep/.myCell .el-checkbox__input {
  display: none;
}
/deep/.el-input-number--mini{
  width: 110px;
}
/deep/.cancel{
  width: 50px;
  padding: 6px 0 !important;
  margin-left: 2px;
}
</style>
